<div id="tx-drag-drop-upload"
  class="mt-2 max-w flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed" txDragDropUpload
  (click)="fileField.click()" (filesDropped)="onFileAdded($event)">
  <div class="space-y-1 text-center">
    <mat-icon class="mx-auto h-12 w-12" svgIcon="feather:upload-cloud"></mat-icon>
    <div class="text-sm text-gray-600">
      <div class="cursor-pointer font-medium hover:text-primary-500 focus:outline-none focus:ring-2 focus:ring-offset-2"
        style="color: rgb(37, 99, 235)">
        {{'Upload file' | transloco}}
      </div>
      <input type="file" name="files" #fileField (change)="onFileAdded($any($event).target.files)" multiple hidden />
    </div>
    <p class="text-xs text-gray-900">
      {{ "Files up to 5Mb" | transloco }}
    </p>
    <div class="text-xs text-gray-900">
      {{ "Metadata from files is removed automatically" | transloco }}
    </div>
  </div>
</div>
<div class="tx-queue space-y-2 mt-5" *ngIf="fileQueue.length > 0">
  <div class="flex flex-col bg-gray-50 shadow overflow-hidden rounded-none" *ngFor="let file of fileQueue">
    <div class="flex justify-between items-center py-2 px-5">
      <div class="flex flex-col">
        <div class="font-bold">{{ file.name }}</div>
        {{ file.type }} - {{ "metadados removed" | transloco }}
      </div>
      <button mat-flat-button [color]="'secondary'" class="rounded-none shadow" (click)="onFileRemoved(file)">
        <mat-icon svgIcon="feather:x"></mat-icon>
        {{ "Remove" | transloco }}
      </button>
    </div>
  </div>
</div>